module.exports = __webpack_public_path__ + "static/img/gpt16.ff88aa55.png";